import MediaPreviewEmbed from '../MediaPreviewEmbed/MediaPreviewEmbed';

function MediaPreviewYoutubeNoCookie2({
  linkUrl,
  getHeightOfIframe,
}: {
  linkUrl: string;
  getHeightOfIframe?: (mediaPreviewType: number) => number;
}) {
  if (!linkUrl) {
    return <div>Youtube NoCookie URL could not be parsed</div>;
  }
  return <MediaPreviewEmbed url={linkUrl} getHeightOfIframe={getHeightOfIframe} />;
}

export default MediaPreviewYoutubeNoCookie2;
